<template>
	<!-- antdesign全局中文-LocaleProvider 国际化。https://1x.antdv.com/components/locale-provider-cn/ -->
	<a-config-provider :locale="zh_CN" >
		<div id="app">
			<router-view/>
		</div>
	</a-config-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

moment.locale('zh-cn');
export default {
    name: 'app',
    data() {
        return {
          zh_CN,
        };
    },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* color: #2c3e50; */
  /* min-height: 100vh; */
  /* overflow: hidden; */
  color: rgba(0,0,0,.85);
}
.detel_color {
    border: none !important;
    background-color: red !important;
}

/* input数字输入框的右边箭头去掉 */
input[type=number] {
    -moz-appearance:textfield;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.zzzzz input {
    height:40px !important;
}

/* 页面的标题 */
.page-title {
	text-align: left;
	font-weight: 500;
	font-size: 22px;
}
/* 页面加载中的样式 */
.loading-box {
	position: fixed;
	width: 100%;
	height: 100vh;
	left: 0;
	top: 0;
	z-index: 111;
	text-align: center;
	line-height: 100vh;
}

/* 必填提示 */
.required-hint {
	color: red;
	position: absolute;
	right: -8px;
}

/* 侧边栏样式 */
.form-cell-box {
	display: flex;
	align-items: center;
	margin-bottom: 15px;
}
.class-title {
	position: relative;
	font-size: 14px;
	margin-right: 20px;
	width: 90px;
	color: #333;
	text-align: right;
	flex-shrink: 0;
}

/* 搜索条件的样式 */
.screen-box {
	display: flex;
	align-items: center;
	margin-right: 17px;
	margin-bottom: 10px;
}
.screen-label {
	flex-shrink: 0;
	margin-right: 10px;
	font-size: 14px;
}
/* 搜索条件的样式-更小间距版 */
.jl-screen-box {
	display: flex;
	align-items: center;
	margin-right: 10px;
	margin-bottom: 15px;
}

/* 表格部分的样式开始（不包括表头的hover效果，和某些页面表头的height属性等等） */
.table-th {
	position:sticky;
	top: 65px;
	z-index:3;
	display: flex;
	align-items: center;
	/* background-color: #fbfbfb; */
	background-color: #fafafa;
	border-bottom: 1px solid #e8e8e8;
}
.table-th-cell {
	display: flex;
	align-items: center;
	padding: 12px 8px;
	cursor: default;
	color: #060606;
	flex-shrink: 0;
	/* user-select: none; */
	font-size: 13px;
}

.table-td {
	display: flex;
	align-items: center;
	width: 100%;
	border-bottom: 1px solid #e8e8e8;
}
.table-td:hover {
	/* background-color: #eff9ff; */
	background-color: #fafafa;
}
.table-td:hover .table-td-cell-sticky{
	/* background-color: #eff9ff; */
	
	background-color: #fafafa;
}
.table-td-cell {
	padding: 12px 8px;
	flex-shrink: 0;
	cursor: default;
	word-break: break-all;
	color: rgba(0, 0, 0, 0.85);
	min-height: 39px;
	font-size: 13px;
	/* overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis; */
}
.table-td-cell-sticky {
	position: sticky;
	left: 30px;
	z-index: 2;
	background-color: #fff;
}
.table-th-cell-sticky {
	position: sticky;
	left: 30px;
	z-index: 2;
	background-color: #fbfbfb;
}

.text-right {
	text-align: right;
}
/* 表格部分样式结束 */


/* 推广账户管理页面的tab样式修改 */
#put-account .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
	padding: 0 30px !important;
}

/* 巨量引擎 创意页的图片查看轮播图样式调整 /JLcy*/
.ant-carousel .slick-dots li.slick-active button {
	background: #eee !important;
}
.ant-carousel .slick-dots li button {
	background: #999 !important;
}

/* 修改/JLzh页的this.$confirm({})颜色 */
.jlzh svg {
    color: #1890ff !important;
}

/* 微信图文消息：草稿箱 导航条样式更改 */
.wx-mater-drafts .ant-menu-inline{
	border-right: none !important;
}

/* /wxMaterialDrafts页面的左侧导航条样式更改 */
.wx-mater-drafts .ant-menu {
	background: transparent !important;
}

/* 微信草稿箱页面tabs修改 */
.wx-mater-drafts .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
	padding: 0 30px !important;
}

/* 不明白ant design的标签组件，默认带一个右边的外边距，这里清0 */
.ant-tag {
	margin-right: 0 !important;
}

/* 侧边栏的回传设置的自定义回传的数字输入框右边的箭头去掉 */
.custom-report-drawer-box .ant-input-number-handler-wrap {
	display: none;
}
/* 气泡弹窗内边距调整 */
.custom-report-drawer-box .ant-popover-inner-content {
	padding: 3px 10px;
}

/* 弹窗组件网上移一点，免得在笔记本上，弹窗过大显示不全，原本值是100px */
.ant-modal {
	top: 70px !important; 
}

.ant-input {
	color: rgba(0,0,0,.85) !important;
}
.ant-btn {
	border-radius: 2px !important;
}


.fans-meesage-box .w-e-text-container {
	background-color: transparent !important;
}
.fans-meesage-box .w-e-text-container p{
	margin: 0 !important;
}

/* 粉丝消息页的富文本图片尺寸进行控制 */
.fans-meesage-box .w-e-text-container img {
	max-width: 260px;
	max-height: 135px;
}

/* 搜索项的内容项的右侧边距 */
.a-col-left-label {
	text-align: right;
    padding-right: 15px !important;
}
.a-col-right-padding {
	padding-right: 12px !important;
}
.a-col-content-margin {
	margin-bottom: 15px;
}
</style>
